import _asyncToGenerator from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/packages/husky-site/node_modules/@babel/runtime/regenerator/index.js";
export var streamCollector = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(stream) {
    var _stream$constructor;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(typeof Blob === "function" && stream instanceof Blob || ((_stream$constructor = stream.constructor) === null || _stream$constructor === void 0 ? void 0 : _stream$constructor.name) === "Blob")) {
              _context.next = 6;
              break;
            }
            _context.t0 = Uint8Array;
            _context.next = 4;
            return stream.arrayBuffer();
          case 4:
            _context.t1 = _context.sent;
            return _context.abrupt("return", new _context.t0(_context.t1));
          case 6:
            return _context.abrupt("return", collectStream(stream));
          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
  return function streamCollector(_x) {
    return _ref.apply(this, arguments);
  };
}();
function collectStream(_x2) {
  return _collectStream.apply(this, arguments);
}
function _collectStream() {
  _collectStream = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(stream) {
    var chunks, reader, isDone, length, _yield$reader$read, done, value, collected, offset, _i, _chunks, chunk;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            chunks = [];
            reader = stream.getReader();
            isDone = false;
            length = 0;
          case 4:
            if (isDone) {
              _context2.next = 14;
              break;
            }
            _context2.next = 7;
            return reader.read();
          case 7:
            _yield$reader$read = _context2.sent;
            done = _yield$reader$read.done;
            value = _yield$reader$read.value;
            if (value) {
              chunks.push(value);
              length += value.length;
            }
            isDone = done;
            _context2.next = 4;
            break;
          case 14:
            collected = new Uint8Array(length);
            offset = 0;
            for (_i = 0, _chunks = chunks; _i < _chunks.length; _i++) {
              chunk = _chunks[_i];
              collected.set(chunk, offset);
              offset += chunk.length;
            }
            return _context2.abrupt("return", collected);
          case 18:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _collectStream.apply(this, arguments);
}